import { Stack } from "@/Components/v2/atoms/Stack";
import { ViewModeSelector } from "@/Components/v2/molecule/ViewModeSelector";
import { Config } from "@/hooks/useConfig";
import { MROIColumnSelector } from "@/pages/channel-roi/constants/types";
import { useMROIStore } from "@/pages/channel-roi/store/useMROIStore";
import ChartSettings from "@/shared/components/Chart/ChartSettings";

import { getColumnViewOptions } from "./helpers/getColumnViewOptions";

type ColumnChartViewSelectorProps = {
  config: Config;
  hasSharedRevenue: boolean;
  hasRoiRevenue: boolean;
};

const ColumnChartViewSelector = ({
  config,
  hasSharedRevenue,
  hasRoiRevenue,
}: ColumnChartViewSelectorProps) => {
  const columnView = useMROIStore((state) => state.chart.channelEffectiveness.column.selector);
  const funnelStage = useMROIStore((state) => state.filters.funnelStage);
  const { isAscending, showInsufficientData } = useMROIStore((state) => state.chart);
  const { setColumnSelector, setIsAscending, setShowInsufficientData } = useMROIStore();

  const options = getColumnViewOptions(
    hasSharedRevenue,
    hasRoiRevenue,
    funnelStage || "all",
    config
  );

  const width =
    columnView === MROIColumnSelector.SHARE_OF_EFFECT_AMOUNT ||
    columnView === MROIColumnSelector.SHARE_OF_EFFECT_PERCENTAGE
      ? 400
      : 280;

  return (
    <Stack direction="row" justifyContent="flex-end">
      <ViewModeSelector
        options={options}
        value={columnView}
        onChange={(value) => setColumnSelector(value as MROIColumnSelector)}
        width={width}
      />
      <ChartSettings
        isAscending={isAscending}
        setIsAscending={setIsAscending}
        filterInsufficientData={showInsufficientData}
        setFilterInsufficientData={setShowInsufficientData}
      />
    </Stack>
  );
};

export default ColumnChartViewSelector;
